import { JSX, For } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { upiApps } from "~/data/upi_apps";
import { UpiAppTile } from "./upi_app_tile";
import { toRupees } from "~/utils/number";
import { goBack } from "~/shared_states/modal";
import { usePaymentLoaderContext } from "../context/payment_loader_context";

export function IosUpiAppsView(): JSX.Element {
  const { components } = useTelescopeContext();
  const { amount, loadingAppName, launchUpiApp } = usePaymentLoaderContext();

  // Convert upiApps object to array
  const appsArray = Object.values(upiApps);

  // Create pairs for 2-column grid
  const getAppPairs = () => {
    const pairs: [
      (typeof appsArray)[number],
      (typeof appsArray)[number] | undefined,
    ][] = [];
    for (let i = 0; i < appsArray.length; i += 2) {
      pairs.push([appsArray[i], appsArray[i + 1]]);
    }
    return pairs;
  };

  return (
    <div class="relative flex flex-col overflow-hidden bg-background-normal-primary">
      {/* Header */}
      <components.ModalHeader
        size="large"
        title={toRupees(amount)}
        description="Scan & pay via any UPI app"
        onClose={() => goBack()}
      />

      {/* Content - UPI Apps Grid */}
      <div class="flex flex-col gap-6 px-5 pb-6 pt-5">
        <div class="flex flex-col gap-3">
          <For each={getAppPairs()}>
            {(pair) => (
              <div class="flex gap-3">
                <UpiAppTile
                  app={pair[0]}
                  isLoading={loadingAppName() === pair[0].name}
                  onClick={() => launchUpiApp(pair[0])}
                />
                {pair[1] && (
                  <UpiAppTile
                    app={pair[1]}
                    isLoading={loadingAppName() === pair[1].name}
                    onClick={() => launchUpiApp(pair[1]!)}
                  />
                )}
                {!pair[1] && <div class="flex-1" />}
              </div>
            )}
          </For>
        </div>
      </div>

      {/* Footer */}
      <div class="flex flex-col items-center gap-4 pb-6">
        <div class="h-px w-full bg-[#edeef1]" />
        <div class="px-6">
          <p class="text-center text-para-3-regular tracking-[-0.14px] text-text-normal-secondary">
            Note: You'll be redirected to another page once payment is
            processed.
          </p>
        </div>
      </div>
    </div>
  );
}
